export const STEPS = [
  {
    title: 'ボトルを選ぶ',
    includeCompletedImage: true,
  },
  {
    title: 'キャップを選ぶ',
    includeCompletedImage: true,
  },
  {
    title: 'スティックを選ぶ',
    includeCompletedImage: true,
  },
  {
    title: 'オイルを選ぶ',
    includeCompletedImage: false,
  },
]
